import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { toggleRoktAds } from 'Redux/ducks/auth';
import store from 'Redux/store';

function PreferenceCard({
  title,
  customDisabled,
  actionText,
  roktAdverts,
}) {
  const [preferenceValue, setPreferenceValue] = useState(false);
  const disabledMessage = customDisabled || 'Disabled';
  const switchText = preferenceValue ? `Enable ${actionText}` : `Disable ${actionText}`;

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (roktAdverts) setPreferenceValue(roktAdverts);
  }, []);

  const updatePreference = async (e) => {
    if (e) e.preventDefault();

    await store.dispatch(toggleRoktAds(!preferenceValue));
    setPreferenceValue(!preferenceValue);
  };

  return (
    <div className="account-table-row">
      <div className="account-table-row-title">
        <FormattedMessage
          id="PreferenceCard.title"
          defaultMessage="{title}"
          values={{ title }}
        />
      </div>
      <div className="account-table-row-content">
        {preferenceValue ? disabledMessage : 'Enabled'}
        <div className="account-table-action-container">
          {/* eslint-disable jsx-a11y/interactive-supports-focus */}
          <a
            className="account-table-action-button"
            target="_blank"
            rel="noopener noreferrer"
            role="button"
            value={preferenceValue}
            onClick={e => updatePreference(e)}
          >
            <FormattedMessage
              id="PreferenceCard.switch"
              defaultMessage="{switchText}"
              values={{ switchText }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

PreferenceCard.propTypes = {
  title: PropTypes.string,
  customDisabled: PropTypes.string,
  actionText: PropTypes.string,
  roktAdverts: PropTypes.bool,
};

PreferenceCard.defaultProps = {
  title: '',
  customDisabled: '',
  actionText: '',
  roktAdverts: true,
};

const mapStateToProps = ({
  auth: { rokt_opt_out: roktAdverts },
}) => ({
  roktAdverts,
});

export default connect(mapStateToProps, { toggleRoktAds })(PreferenceCard);
